
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M14.998 23.253h-6l.75-4.5h4.5l.75 4.5zM6.748 23.253h10.5"}}),_c('rect',{staticClass:"a",attrs:{"x":".748","y":".753","width":"22.5","height":"18","rx":"3","ry":"3"}}),_c('path',{staticClass:"a",attrs:{"d":"M.748 11.253l3.97-3.969a.75.75 0 011.061 0l1.939 1.939a.75.75 0 001.061 0l3.969-3.97M.748 15.753h22.5M14.248 9.753v2.25M20.248 9.753v2.25M17.248 7.503v4.5"}})])
          )
        }
      }
    